export const breadcrumbExpander = function () {
    Array.from(document.querySelectorAll('.breadcrumb-collapse')).forEach(i => {
        i.addEventListener('click', function() {
            this.closest('.breadcrumb').classList.add('breadcrumb-active');
        });
    });
}

export const artDropdownSelect = function () {
    Array.from(document.querySelectorAll('.dropdown-select .nav-item')).forEach(i => {
        i.addEventListener('click', function() {
            this.closest('.dropdown-select').querySelector('.dropdown-label').innerHTML = this.querySelector('.nav-link').innerHTML;
        });
    });
}